<template>
  <div
    class="starsBar d-flex w-100 justify-content-center border-bottom pb-3 mb-2 mt-3 "
    :class="customClass"
  >
    <div class="parent-stars-container d-flex" v-if="userIsAParent">
      <parent-star-card
        v-for="(element, index) in data.filter((d) => d.display)"
        :key="'stars-' + index"
        :text="element.text"
        :value="element.stars"
        :first="index > 0"
        :showStar="showParentStar"
      />
    </div>
    <div class="child-stars-container d-flex m-0 p-0" v-else>
      <child-star-card
        v-for="(element, index) in data.filter((d) => d.display)"
        :key="'stars-' + index"
        :text="element.text"
        :value="element.stars"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import childStarCard from './childStarCard.vue';
import parentStarCard from './parentStarCard.vue';
export default {
  components: {
    childStarCard,
    parentStarCard,
  },
  props: {
    customClass: String,
    data: {
      type: Array,
      default: () => [],
    },
    showParentStar: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters('user', ['userIsAParent']),
  },
};
</script>

<style scoped lang="scss">
* {
  text-align: center;
}

.child-stars-container {
  flex-wrap: wrap;
  justify-content: center;
  flex: 1;
  gap: 0.5rem;
}

.starsBar {
  & > div {
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
}
</style>
